import React from 'react';
// FIX: Replaced v5 imports (Redirect, Route, RouteProps) with v6 equivalents (Navigate, Outlet).
import { Outlet, Navigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

// FIX: Rewrote the component to follow the standard react-router-dom v6 pattern.
// It now acts as a wrapper that renders child routes via <Outlet /> if authenticated,
// or redirects to the login page.
const ProtectedRoute = () => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    // You can add a loading spinner here if you want
    return null; 
  }

  return isAuthenticated ? <Outlet /> : <Navigate to="/login" />;
};

export default ProtectedRoute;
